// Smart icon & color suggestions based on account name and type
// Returns { icon, color } or null if no match

const NAME_PATTERNS = [
  // Indian Banks
  { patterns: ['hdfc'], icon: '🏦', color: '#004c8f' },
  { patterns: ['icici'], icon: '🏦', color: '#f37920' },
  { patterns: ['sbi', 'state bank'], icon: '🏛️', color: '#2d5f9a' },
  { patterns: ['axis'], icon: '🏦', color: '#97144d' },
  { patterns: ['kotak'], icon: '🏦', color: '#ed1c24' },
  { patterns: ['bob', 'bank of baroda'], icon: '🏛️', color: '#f47920' },
  { patterns: ['pnb', 'punjab national'], icon: '🏛️', color: '#003d7c' },
  { patterns: ['canara'], icon: '🏛️', color: '#fdb913' },
  { patterns: ['union bank'], icon: '🏛️', color: '#e31e25' },
  { patterns: ['idbi'], icon: '🏦', color: '#00723f' },
  { patterns: ['idfc'], icon: '🏦', color: '#9c1d26' },
  { patterns: ['yes bank'], icon: '🏦', color: '#0070ba' },
  { patterns: ['indusind'], icon: '🏦', color: '#6c1d45' },
  { patterns: ['federal bank'], icon: '🏛️', color: '#003399' },
  { patterns: ['rbl'], icon: '🏦', color: '#004990' },

  // International Banks
  { patterns: ['chase', 'jp morgan'], icon: '🏦', color: '#117aca' },
  { patterns: ['citibank', 'citi'], icon: '🏦', color: '#003b70' },
  { patterns: ['hsbc'], icon: '🏦', color: '#db0011' },
  { patterns: ['barclays'], icon: '🏦', color: '#00aeef' },
  { patterns: ['standard chartered'], icon: '🏦', color: '#0072aa' },
  { patterns: ['dbs'], icon: '🏦', color: '#e31837' },

  // Digital Wallets & UPI
  { patterns: ['paytm'], icon: '💳', color: '#00baf2' },
  { patterns: ['phonepe', 'phone pe'], icon: '💳', color: '#5f259f' },
  { patterns: ['gpay', 'google pay'], icon: '💳', color: '#4285f4' },
  { patterns: ['amazon pay'], icon: '💳', color: '#ff9900' },
  { patterns: ['paypal'], icon: '💳', color: '#003087' },
  { patterns: ['razorpay'], icon: '💳', color: '#2d67e3' },
  { patterns: ['mobikwik'], icon: '💳', color: '#e3002b' },
  { patterns: ['freecharge'], icon: '💳', color: '#7b2d8e' },
  { patterns: ['upi'], icon: '💳', color: '#6c3ea0' },

  // Cards
  { patterns: ['visa'], icon: '💳', color: '#1a1f71' },
  { patterns: ['mastercard'], icon: '💳', color: '#eb001b' },
  { patterns: ['rupay'], icon: '💳', color: '#097252' },
  { patterns: ['amex', 'american express'], icon: '💳', color: '#006fcf' },
  { patterns: ['credit card', 'cc'], icon: '💳', color: '#f59e0b' },
  { patterns: ['debit card'], icon: '💳', color: '#3b82f6' },

  // Cash & Savings
  { patterns: ['cash', 'hand cash'], icon: '💵', color: '#22c55e' },
  { patterns: ['savings', 'saving'], icon: '🐷', color: '#ec4899' },
  { patterns: ['emergency fund', 'emergency'], icon: '🐷', color: '#ef4444' },
  { patterns: ['fixed deposit', 'fd'], icon: '🏛️', color: '#8b5cf6' },
  { patterns: ['mutual fund', 'mf'], icon: '📊', color: '#10b981' },
  { patterns: ['investment', 'invest'], icon: '📈', color: '#22c55e' },
  { patterns: ['stock', 'demat', 'zerodha', 'groww', 'upstox'], icon: '📈', color: '#6366f1' },

  // Crypto
  { patterns: ['crypto', 'bitcoin', 'btc', 'eth', 'wazirx', 'coinbase', 'binance'], icon: '🪙', color: '#f7931a' },

  // Business
  { patterns: ['business', 'company', 'firm'], icon: '💼', color: '#64748b' },
  { patterns: ['salary', 'income'], icon: '💰', color: '#22c55e' },
  { patterns: ['expense', 'spending'], icon: '🧾', color: '#f97316' },

  // Other
  { patterns: ['home loan', 'mortgage'], icon: '🏠', color: '#6366f1' },
  { patterns: ['car loan', 'vehicle'], icon: '🚗', color: '#3b82f6' },
  { patterns: ['education', 'school', 'college', 'university'], icon: '🎓', color: '#0f172a' },
  { patterns: ['gold', 'jewel'], icon: '💎', color: '#eab308' },
];

// Type-based fallback suggestions
const TYPE_DEFAULTS = {
  bank: { icon: '🏦', color: '#0ea5e9' },
  wallet: { icon: '💳', color: '#8b5cf6' },
  cash: { icon: '💵', color: '#22c55e' },
  credit_card: { icon: '💳', color: '#f59e0b' },
  other: { icon: '📌', color: '#6b7280' }
};

export function suggestAccountIconColor(name, type) {
  if (!name || name.trim().length < 2) return null;

  const lower = name.toLowerCase().trim();

  for (const entry of NAME_PATTERNS) {
    for (const pattern of entry.patterns) {
      if (lower.includes(pattern)) {
        return { icon: entry.icon, color: entry.color };
      }
    }
  }

  if (type && TYPE_DEFAULTS[type]) {
    return TYPE_DEFAULTS[type];
  }

  return null;
}
